export default __webpack_public_path__ + "static/media/C03.bfc64be1.png";